import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { EmbeddedObjectAnnotation } from "@shared/models/embedded-object-annotation";
import { PdfViewerComponent } from "../pdf-viewer/pdf-viewer.component";
import { AnnotationElement, Doc } from "@shared/models/common";
import { NgRedux } from "@shared/redux/redux-compatibility.service";
import { AppState } from "@shared/redux/store";
import { BoundingBox, CatDoc } from "@shared/models/cat.model";
import { CatService } from "@shared/services/cat.service";


@Component({
    selector: 'view-page-and-annotate-element',
    templateUrl: './view-page-and-annotate-element.component.html',
    styleUrls: ['./view-page-and-annotate-element.component.scss'],
    standalone: false
})
export class ViewPageAndAnnotateElement implements OnInit {


    displayDocViewer: boolean = true;
    @ViewChild('docViewer') docViewer: PdfViewerComponent;
    
    @Output() closePdfViewerEmitter: EventEmitter<void> = new EventEmitter<void>();

    @Input() embeddedObjectAnnotation: EmbeddedObjectAnnotation; // EmbeddedObjectAnnotation

    // doc Doc
    curDoc: CatDoc = new CatDoc();
    curPage: number = 1; // Current page to display in the PDF viewer

constructor(private ngRedux: NgRedux<AppState>, private catService: CatService) {

}

ngOnInit(): void {
    // load first annotation page from embeddedObjectAnnotation
    this.curDoc = new CatDoc();

    if (this.embeddedObjectAnnotation) {

      this.curDoc.docName = this.embeddedObjectAnnotation.docName;
      this.curPage = this.embeddedObjectAnnotation.pageNum + 1;
      this.curDoc.versionId = this.embeddedObjectAnnotation.versionId;
      this.curDoc.docId = this.embeddedObjectAnnotation.docId;
      this.curDoc.docS3Key = this.embeddedObjectAnnotation.docS3Key;
      this.curDoc.pagesNum = this.embeddedObjectAnnotation.pageCnt;

    }
    
}  


onDocIframeLoaded() {
    // when the PDF viewer is loaded, we can show the annotations
    if (this.embeddedObjectAnnotation) {
      // Show annotations for the current page
      this.onToggleAnnotations(true);
    } else {
      // No annotations to show, hide them
      this.onToggleAnnotations(false);
    }

}

closePdfViewer() {
    
    
    // Reset the displayDocViewer to false to hide the PDF viewer
    this.closePdfViewerEmitter.emit();

}

  onToggleAnnotations(viewSw: boolean) {

    // get all annotations from loaded page that are in the embeddedObjectAnnotation
    let hasAnnotations  = false;
    let annotationElements = this.embeddedObjectAnnotation.annotationPhrases[this.docViewer?.pdfViewer.page - 1];
    let annotationsToShow: AnnotationElement[] = [];
    if (annotationElements?.length) {
      hasAnnotations = true;
      annotationsToShow = annotationElements;
    }

   if (this.embeddedObjectAnnotation.boundingBox && this.embeddedObjectAnnotation.pageNum != undefined && this.embeddedObjectAnnotation.pageNum == this.docViewer?.pdfViewer.page - 1) {
      
    hasAnnotations = true;
    if (annotationsToShow.length === 0 || this.embeddedObjectAnnotation.hasImage) {
      annotationsToShow = [this.embeddedObjectAnnotation.boundingBox];
    }
   }
     
   if (hasAnnotations) {
      
      annotationsToShow.forEach(annotation => {
        this.docViewer.hideAnnotation(annotation, false);
        if (viewSw) {
          this.docViewer.showAnnotation(annotation, true);
        }
      });
   }
  }

}